// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class LunexService {

//   constructor() { }
// }

import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { errorCheck } from '@root/utils/error-check';
import { map } from 'rxjs/operators';
import { HttpService } from '@services/http.service';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LunexService {
    allProducts:any[] = [];
    allProviders:any[] = [];
    currencyRates = {USD:1, EUR:0.9398,GBP:0.8183};
    constructor(
        protected http: HttpService
    ) {
      this.getRates();
    }

    getRates() {
      this.http.get('https://min-api.cryptocompare.com/data/price?fsym=USD&tsyms=,EUR,GBP').subscribe(res => {
        res => {
          this.currencyRates.EUR = res && res.EUR || this.currencyRates.EUR;
          this.currencyRates.GBP = res && res.GBP || this.currencyRates.GBP;
        }
      })
    }

    getSAmerchantsTransactions(body:any){
      return this.http.post(`${environment.API_URL}/api/merchants/getSAmerchantsTransactions`,body)
    }
    getOrder(data:any) {
      // let params = `?seller_id=${environment.lunexSeller}&`
      let params = `?seller_id=${data.seller_id}&`
        if(data && data.From_Date && data.To_Date) {
          try{
            let frm = new Date(data.From_Date);
            let to = new Date(data.To_Date);
            let merchant = data.seller;
            if(frm && to) {
              params += `from_date=${this.getFormatedDate(frm)}&to_date=${this.getFormatedDate(to)}&merchant=${merchant}`;
            }
          } catch {

          }
        }
        console.log(params);
        return this.http.get(`${environment.API_URL}/api/seller/transactions${params}`)
      }

    getFormatedDate(date: Date) {
      let yr = `${date.getFullYear()}`.substring(2);
      let month = `${date.getMonth()+1 >= 10 ? date.getMonth()+1 : '0'+(date.getMonth()+1)}`;
      let dat= `${date.getDate() >= 10 ? date.getDate() : '0'+date.getDate()}`;
      return `${yr}${month}${dat}000000`;
    }

    getAdmins(params = {}) {
        // we will use HttpClient module instead of rxjs/ajax
        // to use angular http interceptor for auth token.
        return this.http.get(`${environment.API_URL}/api/merchants/admins`, params)
            .pipe(
                map(res => errorCheck(res)),
                map(
                    res => res.result,
                    error => { throw error; }
                )
            );
    }

    createAdmin(params) {
        // we will use HttpClient module instead of rxjs/ajax
        // to use angular http interceptor for auth token.
        return this.http.post(`${environment.API_URL}/api/merchants/admins`, params)
            .pipe(
                map(res => errorCheck(res)),
                map(
                    res => res.result,
                    error => { throw error; }
                )
            );
    }

    updateAdmin(id: string, params: any) {
        // we will use HttpClient module instead of rxjs/ajax
        // to use angular http interceptor for auth token.
        return this.http.put(`${environment.API_URL}/api/merchants/admins/${id}`, params)
          .pipe(
            map(res => errorCheck(res)),
            map(
              res => res.result,
              error => { throw error; }
            )
          );
    }

    deleteAdmin(id: string) {
        // we will use HttpClient module instead of rxjs/ajax
        // to use angular http interceptor for auth token.
        return this.http.delete(`${environment.API_URL}/api/merchants/admins/${id}`)
          .pipe(
            map(res => errorCheck(res)),
            map(
              res => res.result,
              error => { throw error; }
            )
          );
    }

    orderTopup(data):Observable<any>{
      // return this.http.post(`${environment.API_URL}/api/seller/orderTopup/${environment.lunexSeller}`,data)
      return this.http.post(`${environment.API_URL}/api/seller/orderTopup/APG01D999TEST`,data)
    }
    phoneTopup(data):Observable<any>{
      // return this.http.post(`${environment.API_URL}/api/seller/phoneTopup/${environment.lunexSeller}`,data)
      return this.http.post(`${environment.API_URL}/api/seller/phoneTopup/APG01D999TEST`,data)
    }
    getProducts(type= 'GIFT_CARD'):Observable<any>{
      if(this.allProducts && this.allProducts.length) {
        return of({error:false,msg: "Success", body: this.allProducts});
      }
      return this.http.get(`${environment.API_URL}/api/seller/listProduct?seller_id=${environment.lunexSeller}&type=${type}`)
    }
    getProviders(type = 'TOPUP'):Observable<any>{
      if(this.allProviders && this.allProviders.length) {
        return of({error:false,msg: "Success", body: this.allProviders});
      }
      return this.http.get(`${environment.API_URL}/api/seller/listProduct?seller_id=${environment.lunexSeller}&type=${type}`)
    }
    getTransactionsAll():Observable<any>{
      return this.http.get(`${environment.API_URL}/api/seller/getTransactions`)
    }

    getTransactions():Observable<any>{
      return this.http.get(`${environment.API_URL}/api/seller/getTransactions?type=Payrix`)
    }

    getStripeTransactions():Observable<any>{
      return this.http.get(`${environment.API_URL}/api/seller/getTransactions?type=Stripe`)
    }

    getWorldNetTransaction():Observable<any>{
      return this.http.get(`${environment.API_URL}/api/seller/getTransactions?type=Worldnet`)
    }

    getPayalTransactions():Observable<any>{
      return this.http.get(`${environment.API_URL}/api/seller/getTransactions?type=Paypal`)
    }
    getvCardTransactions():Observable<any>{
      return this.http.get(`${environment.API_URL}/api/seller/getTransactions?type=`)
    }

    getSuperAdminTransaction() {
      return this.http.get(`${environment.API_URL}/api/transactions/?limit=100`)
    }

    getMerchantPoynt() {
      return this.http.post(`${environment.API_URL}/api/transactions/poynt`, {})
    }

    fetchCutomerDetails(item) {
      let decoded:any = { response: null, customer:'', address: { address1:'', city:'', state:'', zip:''}}
      if(item.paymentResponse) {
        decoded.response = (item.paymentResponse) ? JSON.parse(item.paymentResponse) : null;
        decoded.customer = (decoded.response) ? `${decoded.response.first} ${decoded.response.last}` : '';
        decoded.address.address1 = decoded.response.address1;
        decoded.address.city = decoded.response.city;
        decoded.address.state = decoded.response.state;
        decoded.address.zip = decoded.response.zip;
      } else if (item.paypalResponse) {
        decoded.response = (item.paypalResponse) ? JSON.parse(item.paypalResponse) : null;
        decoded.customer = (decoded.response) ? `${decoded.response.payer.name.given_name} ${decoded.response.payer.name.surname}` : '';
        decoded.address.address1 = `${decoded.response.payer.address.address_line_1} ${decoded.response.payer.address.address_line_2}`;
        decoded.address.city = `${decoded.response.payer.address.admin_area_2}`;
        decoded.address.state = `${decoded.response.payer.address.admin_area_1}`;
        decoded.address.zip = `${decoded.response.payer.address.postal_code}`;
      } else if (item.stripeResponse) {
        decoded.response = (item.stripeResponse) ? JSON.parse(item.stripeResponse) : null;
        decoded.customer = (decoded.response) ? `${decoded.response.billing_details.name}` : '';
        decoded.address.address1 = `${decoded.response.billing_details.address.line1}`;
        decoded.address.city = `${decoded.response.billing_details.address.city}`;
        decoded.address.state = `${decoded.response.billing_details.address.state}`;
        decoded.address.zip = `${decoded.response.billing_details.address.postal_code}`;
      } else if(item.worldnetResponse){
        decoded.response = (item.worldnetResponse) ? JSON.parse(item.worldnetResponse) : null;
        if (decoded.response && decoded.response.customerAccount && decoded.response.customerAccount.cardholderName) {
          decoded.customer = decoded.response.customerAccount.cardholderName;
        } else if (decoded.response && !decoded.response.customerAccount){
          decoded.customer = item.cardHolderFirstName + item.cardHolderLastName;
        } else {
          decoded.customer = '';
        }

        if(decoded.response && decoded.response.merchantReceipt){
          const address = decoded.response.merchantReceipt.merchantDetails.Address;
          if(address){
            decoded.address.address1 = address.split(',')[0];
            decoded.address.city = `----`;
            decoded.address.state = address.split(',')[2];
            decoded.address.zip = `----`;
          }
        }else{
          // console.log(item.worldnetResponse,'dataof address')
        }
        
        // decoded.address.address1 = `${decoded.response.customerAccount.address?.line1}`;
        // decoded.address.city = `${decoded.response?.customerAccount?.address?.city}`;
        // decoded.address.state = `${decoded.response?.customerAccount?.address?.state}`;
        // decoded.address.zip = `${decoded.response?.customerAccount?.address?.postal_code}`;
      }
      return decoded;
    }
}
